var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cycle-zone-display__toptab__info-text"}},[_vm._v(" Total capacity : "+_vm._s(_vm.capacity < 0 ? 0 : _vm.capacity)+" "),_c('span',{class:{
		'cycle-zone-display__toptab__info-text__capacity--pos' : _vm.capacityChange > 0,
		'cycle-zone-display__toptab__info-text__capacity--neg' : _vm.capacityChange < 0,
	}},[_vm._v(" "+_vm._s(_vm.capacityChange == 0 ? '' : _vm.capacityChange)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }